import React, {FC} from 'react';

/** The selected tile takes the same colour as the badge the key will carry: purple for personal, amber for global admin. */
export const AccessCard: FC<{
  selected: boolean;
  onSelect: () => void;
  icon: React.ReactNode;
  tone: 'personal' | 'admin';
  title: string;
  description: string;
}> = ({selected, onSelect, icon, tone, title, description}) => {
  const tile = !selected ? 'bg-gray-100 text-gray-500' : tone === 'admin' ? 'bg-[#fdf1e3] text-[#95591a]' : 'bg-[#e4e0f8] text-[#654dcb]';

  return (
    <button
      type="button"
      onClick={onSelect}
      className={`flex w-full items-start gap-3 rounded-lg border p-3 text-left transition-colors ${
        selected ? 'border-[#654dcb] bg-[#f8f7fe]' : 'border-[#ebecf0] hover:border-[#c9c2ee]'
      }`}
    >
      <span
        className={`flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg transition-colors [&>svg]:h-[22px] [&>svg]:w-[22px] ${tile}`}
      >
        {icon}
      </span>
      <span>
        <span className="block text-[13px] font-medium text-[#33364b]">{title}</span>
        <span className="mt-0.5 block text-[12px] leading-normal text-gray-500">{description}</span>
      </span>
    </button>
  );
};
